import React from 'react';
import './clients.css'
import ClientTablePage from "./ClientTablePage";

function Clients(props) {
    return (
       <ClientTablePage />
    );
}

export default Clients;